// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"57e47e04","83":"dfa56d0c","213":"fed1fdf7","325":"35309e0d","483":"14adfcbc","541":"519f5475","615":"31f672b8","825":"cb3cd3c0"}[chunkId] + ".chunk.js";
};